module.exports = __webpack_public_path__ + "static/media/delete.e91bfca2.svg";